import { environment } from "@relay";
import { Toaster } from "@shadcn/ui/sonner";
import { RouterProvider } from "@tanstack/react-router";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RelayEnvironmentProvider } from "react-relay";
import "unfonts.css";
import { HelpProvider } from "./contexts/HelpContext";
import "./index.css";
import { IntercomProvider } from "./providers/IntercomProvider";
import { router } from "./router";
import { initializeTheme } from "@utils/themes";

// Initialize theme system
initializeTheme();

const rootElement = document.getElementById("app");
if (!rootElement) {
	throw new Error("Root element not found");
}

const strict = false;

const StrictModeComponent = strict ? StrictMode : React.Fragment;

if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictModeComponent>
			<RelayEnvironmentProvider environment={environment}>
				<IntercomProvider>
					<HelpProvider>
						<RouterProvider router={router} />
						<Toaster />
					</HelpProvider>
				</IntercomProvider>
			</RelayEnvironmentProvider>
		</StrictModeComponent>
	);
}
